import type { LinkProps } from '@mui/material/Link';

import { mergeClasses } from 'minimal-shared/utils';

import Link from '@mui/material/Link';
import { styled, useTheme } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

import { logoClasses } from './classes';

// ----------------------------------------------------------------------

export type LogoProps = LinkProps & {
  disabled?: boolean;
};

export function Logo({ sx, disabled, className, href = '/', ...other }: LogoProps) {
  const theme = useTheme();

  const PRIMARY_MAIN = theme.vars.palette.primary.main;

  /*
    * OR using local (public folder)
    *
    const singleLogo = (
      <img
        alt="Single logo"
        src={`${CONFIG.assetsDir}/logo/logo-single.svg`}
        width="100%"
        height="100%"
      />
    );

    const fullLogo = (
      <img
        alt="Full logo"
        src={`${CONFIG.assetsDir}/logo/logo-full.svg`}
        width="100%"
        height="100%"
      />
    );
    *
    */

  const logo = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1555 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1368.41 203.321L1428.59 263.907L1488.78 203.321L1428.59 134.08L1368.41 203.321Z"
        fill={PRIMARY_MAIN}
      />
      <path
        d="M1308.46 312.794C1281.93 281.59 1261.09 251.529 1245.93 222.609C1230.01 193.689 1222.06 163.246 1222.06 131.282C1222.06 93.9903 1234.56 62.787 1259.57 37.6722C1284.58 12.5574 1317.55 0 1358.48 0C1394.1 0 1423.66 7.99109 1447.15 23.9733C1471.4 39.1944 1492.62 57.8402 1510.81 79.9108L1485.8 108.45C1474.43 100.079 1462.31 93.9903 1449.42 90.1851C1436.54 85.6187 1422.14 83.3356 1406.22 83.3356C1375.91 83.3356 1352.41 92.0877 1335.74 109.592C1319.07 127.096 1310.73 150.308 1310.73 179.229C1310.73 202.821 1316.41 226.414 1327.78 250.007C1339.15 272.838 1352.41 293.767 1367.57 312.794H1308.46Z"
        fill={PRIMARY_MAIN}
      />
      <path
        d="M1140.05 884.727C1093.82 884.727 1051.76 874.453 1013.86 853.904C976.724 833.356 943.756 805.197 914.956 769.427C886.913 732.896 863.419 691.419 844.471 644.994C905.103 623.685 953.987 603.517 991.124 584.491C1029.02 565.464 1056.68 545.296 1074.11 523.987C1091.55 501.916 1100.26 476.801 1100.26 448.642C1100.26 425.811 1093.82 408.306 1080.94 396.129C1068.81 383.191 1054.03 376.723 1036.6 376.723C1021.44 376.723 1008.18 381.669 996.809 391.563C986.198 401.457 980.893 415.917 980.893 434.943C980.893 460.058 990.366 482.129 1009.31 501.155C1028.26 520.181 1049.86 536.925 1074.11 551.385L1027.5 585.632C1000.98 574.216 975.209 560.517 950.198 544.535C925.187 527.792 904.724 508.385 888.808 486.314C873.65 463.483 866.071 437.607 866.071 408.687C866.071 372.917 878.198 344.378 902.45 323.068C926.703 300.997 957.398 289.962 994.535 289.962C1021.82 289.962 1046.45 295.29 1068.43 305.944C1090.41 316.599 1110.49 330.298 1128.68 347.041C1149.15 366.068 1165.06 388.138 1176.43 413.253C1188.56 437.607 1194.62 463.863 1194.62 492.022C1194.62 524.748 1187.42 553.668 1173.02 578.783C1158.62 603.898 1137.4 626.729 1109.36 647.278C1081.31 667.065 1046.07 686.853 1003.63 706.64C997.566 710.445 992.64 714.25 988.851 718.056C985.061 721.861 983.166 725.666 983.166 729.472C983.166 736.321 985.44 743.171 989.988 750.02C995.293 756.109 1001.73 762.197 1009.31 768.285C1018.41 773.613 1029.02 778.179 1041.15 781.984C1054.03 785.029 1068.43 786.551 1084.35 786.551C1127.55 786.551 1168.85 773.232 1208.26 746.595C1247.67 719.197 1280.26 682.667 1306.03 637.003L1315.13 796.825C1296.94 824.223 1272.3 845.913 1241.23 861.895C1210.16 877.116 1176.43 884.727 1140.05 884.727ZM1394.7 1024L1288.98 952.08V364.165H1409.48V1024H1394.7ZM1240.09 404.12L1183.25 317.36V303.661H1499.29L1555 391.563V404.12H1240.09Z"
        fill={PRIMARY_MAIN}
      />
      <path
        d="M289.896 934.956C242.906 934.956 200.843 922.399 163.706 897.284C127.327 872.169 95.4951 838.683 68.2108 796.825C41.6844 754.967 18.9474 708.923 0 658.693L60.2528 632.437C86.0214 693.321 114.821 740.126 146.653 772.852C179.243 805.577 217.895 821.94 262.611 821.94C291.412 821.94 314.527 813.949 331.959 797.966C350.149 781.223 359.243 760.675 359.243 736.321C359.243 720.339 356.591 704.737 351.285 689.516C346.738 674.295 339.917 660.215 330.822 647.277C321.727 633.578 310.359 621.782 296.717 611.888L339.917 592.482C367.201 615.313 389.18 637.003 405.854 657.552C422.528 678.1 434.275 699.029 441.096 720.339C448.675 740.887 452.465 763.719 452.465 788.834C452.465 833.736 436.928 869.506 405.854 896.143C375.538 922.018 336.885 934.956 289.896 934.956ZM238.738 672.392L185.306 566.225C242.148 551.765 286.485 536.163 318.317 519.42C350.906 501.916 367.201 480.606 367.201 455.492C367.201 438.748 361.138 425.81 349.012 416.678C337.643 407.545 322.485 402.979 303.538 402.979C282.317 402.979 258.822 407.165 233.053 415.536C207.285 423.147 181.137 433.04 154.611 445.217L97.7688 334.484C123.537 321.546 148.927 312.033 173.937 305.944C199.706 299.856 224.717 296.811 248.969 296.811C280.801 296.811 308.843 303.28 333.096 316.218C358.107 329.156 380.843 348.183 401.307 373.298C415.707 390.802 426.696 410.589 434.275 432.66C441.854 453.969 445.644 474.137 445.644 493.164C445.644 536.544 429.349 571.933 396.759 599.331C364.17 626.729 311.496 651.083 238.738 672.392ZM536.591 718.056C500.212 718.056 466.486 709.303 435.412 691.799C404.338 673.534 375.538 649.941 349.012 621.021L356.97 597.048C375.159 605.419 395.243 612.269 417.223 617.596C439.202 622.924 461.181 625.587 483.16 625.587C510.444 625.587 535.076 621.402 557.055 613.03C579.034 603.897 597.223 592.101 611.623 577.641V702.074C601.013 707.401 589.265 711.587 576.381 714.631C564.255 716.914 550.991 718.056 536.591 718.056ZM699.16 1024L593.434 952.08V364.165H713.939V1024H699.16ZM513.854 404.12L458.149 317.36V303.661H803.75L859.456 391.563V404.12H513.854Z"
        fill={PRIMARY_MAIN}
      />
    </svg>
  );

  return (
    <LogoRoot
      component={RouterLink}
      href={href}
      aria-label="Logo"
      underline="none"
      className={mergeClasses([logoClasses.root, className])}
      sx={[
        {
          width: 48.8,
          height: 32,
          ...(disabled && { pointerEvents: 'none' }),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {logo}
    </LogoRoot>
  );
}

// ----------------------------------------------------------------------

const LogoRoot = styled(Link)(() => ({
  flexShrink: 0,
  color: 'transparent',
  display: 'inline-flex',
  verticalAlign: 'middle',
}));
